/* eslint-disable */
<template>
  <div>
    <app-cabin :title="title" :description="description" :slides="slides" :imgDir="imgDir" :facebookUrl="facebookUrl" :vrboUrl="vrboUrl" ></app-cabin>
  </div>
</template >

<script>
import Cabin from './shared/Cabin';

export default {
  components:{
    'app-cabin': Cabin
  },
  data() {
    return {
          title: '',
          description: '<p>Welcome To Beavers Bend Rentals<br>  We are pleased to have you visit our website. If you plan to visit the Beavers Bend area, we hope you will consider staying at one of our cabins.<br>  We are listed on VRBO and AirBNB.  You can also contact us directly, and we will assist you with your reservations.<br>Use the menu button in the top left corner to navigate to our cabin pages.<br>Gary and Michelle Mitchell</p>',
          slides: [],
          imgDir: '../../assets/cabins/main/',
          facebookUrl: '',
          vrboUrl: ''
     };
  },
  mounted() {
    this.importAll(require.context('../assets/cabins/main/', true, /\.jpg$/));
  },
    methods:{
      importAll(r) {
        r.keys().forEach(key => (this.slides.push({ src: r(key), name: key })));
    }
  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
img {
  height: 200px;
  object-fit: contain;
}
p{
  margin-left: 400px;
  margin-right: 100px;
}
.myDiv {
background-color:lightgray;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue